const initCustomSortBy = () => {
  const sortBySelectContainer = document.querySelector('[data-sort-by-select-container]');
  if (!sortBySelectContainer) return;

  const openSortOptionsButton = sortBySelectContainer.querySelector('[data-open-sort-options]');
  const sortInputEl = sortBySelectContainer.querySelector('[data-sort-by-select]');
  const sortByLabelEl = sortBySelectContainer.querySelector('[data-sort-by-label]');
  const sortByListBoxEl = sortBySelectContainer.querySelector('[data-sort-by-select-options]');
  const sortOptionsEls = sortBySelectContainer.querySelectorAll('[data-sort-by-select-option]');

  const ariaSelectedAttribiute = 'aria-selected';
  let currentOptionIndex = [...sortOptionsEls].findIndex(option => option.getAttribute(ariaSelectedAttribiute) === 'true');

  const pseudoFocusState = 'data-focus';

  // declare handleKeydown function here to avoid hoisting issues
  // and to allow it to be used in the setOptionListVisibility function
  let handleKeydown = () => { };

  const setOptionListVisibility = (isOpen) => {
    openSortOptionsButton.setAttribute('aria-expanded', isOpen);
    if (isOpen) {
      sortBySelectContainer.setAttribute('open', '');
      sortBySelectContainer.addEventListener('keydown', handleKeydown);
      sortByListBoxEl.setAttribute('tabindex', '0');
      sortByListBoxEl.focus();
    } else {
      sortBySelectContainer.removeAttribute('open');
      sortBySelectContainer.removeEventListener('keydown', handleKeydown);
      openSortOptionsButton.focus();
      sortByListBoxEl.setAttribute('tabindex', '-1');
      sortOptionsEls.forEach(option => {
        option.removeAttribute(pseudoFocusState);
      });
    }
  };

  const selectOption = (selectedOptionElement) => {
    if (!selectedOptionElement) return;

    const value = selectedOptionElement.dataset.sortByValue;
    sortOptionsEls.forEach(sortOptionsEl => {
      sortOptionsEl.setAttribute(ariaSelectedAttribiute, 'false');
    });
    selectedOptionElement.setAttribute(ariaSelectedAttribiute, 'true');
    sortInputEl.value = value;
    sortByLabelEl.innerText = selectedOptionElement.innerText;
    sortInputEl.dispatchEvent(new Event('change'));
    setOptionListVisibility(false);
  };

  const focusCurrentOption = () => {
    const currentOption = sortOptionsEls[currentOptionIndex];
    currentOption.focus();
    sortOptionsEls.forEach(option => {
      option.removeAttribute(pseudoFocusState);
    });
    currentOption.setAttribute(pseudoFocusState, 'true');
  };

  const moveFocusWithKeyboard = (amount) => {
    currentOptionIndex += amount;
    if (currentOptionIndex < 0) {
      currentOptionIndex = sortOptionsEls.length - 1;
    } else if (currentOptionIndex >= sortOptionsEls.length) {
      currentOptionIndex = 0;
    }
    focusCurrentOption();
  };

  handleKeydown = (e) => {
    const key = e.key;
    switch (key) {
      case 'Escape':
        setOptionListVisibility(false);
        break;
      case 'ArrowDown':
        e.preventDefault();
        moveFocusWithKeyboard(1);
        break;
      case 'ArrowUp':
        e.preventDefault();
        moveFocusWithKeyboard(-1);
        break;
      case 'Enter':
      case ' ':
        const selectedOptionElement = sortOptionsEls[currentOptionIndex];
        selectOption(selectedOptionElement);
        break;
      default:
        break;
    }
  };

  openSortOptionsButton.addEventListener('click', () => {
    const isOpen = openSortOptionsButton.getAttribute('aria-expanded') === 'true';
    setOptionListVisibility(!isOpen);
  });

  sortOptionsEls.forEach(sortOptionsEl => {
    sortOptionsEl.addEventListener('click', () => {
      selectOption(sortOptionsEl);
    });
  });
};

export default initCustomSortBy;
